import { useChatbotSettingsStore } from 'store/useChatbotSettingsStore'
import { useChatbotStore } from 'store/useChatbotStore'
import { classNames } from 'util/classNames'
import { getBaseUrl } from 'util/getBaseUrl'

export const ChatBubble = ({
  presignedUrl,
  size = 60,
  isLoading,
  visualOnly = false,
}: {
  presignedUrl: string | null
  size?: number
  isLoading?: boolean
  visualOnly?: boolean
}) => {
  const { setOpen } = useChatbotStore()
  return (
    <>
      {isLoading ? (
        <ChatBubbleSkeleton size={size} />
      ) : (
        /* eslint-disable-next-line @next/next/no-img-element */
        <img
          onClick={() => !visualOnly && setOpen(true)}
          src={presignedUrl || `${getBaseUrl()}/outcast-logo.png`}
          width={size}
          height={size}
          alt="Outcast"
          style={{
            width: size,
            borderRadius: '50%',
            objectFit: 'cover',
            height: size,
          }}
          className={classNames(
            'select-none overflow-auto rounded-full',
            visualOnly
              ? 'cursor-default'
              : 'cursor-pointer shadow-2xl transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-2xl'
          )}
        />
      )}
    </>
  )
}

export const ChatBubbleSkeleton = ({ size = 60 }: { size?: number }) => {
  const { chatbot } = useChatbotSettingsStore()

  return (
    <div
      className="animate-pulse rounded-full"
      style={{
        width: size,
        height: size,
        backgroundColor: chatbot?.theme_color || '#f2faff',
      }}
    />
  )
}
